import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    BaasicButton,
    TableFilter
} from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { DateRangeQueryPicker, QueryDropdown } from "core/components";

const MissingInventoryFlagReportListTemplate = function({ missingInventoryFlagReportListViewStore }) { 
    const { 
        tableStore, 
        queryUtility, 
        authorization, 
        rangeQueryPickerStore,
        corporateStore,
        facilityStore,
        downloadUrl
        } = missingInventoryFlagReportListViewStore;
        
    return (
        <ApplicationListLayout
            store={missingInventoryFlagReportListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary" label={'Download'} icon='u-icon u-icon--sml u-icon--download--white' onClick={() => { window.open(downloadUrl, "_blank"); }}></BaasicButton>
            </PageNavigation>
            <Content>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-8 col-xxlrg-4 form__group">
                            <DateRangeQueryPicker queryUtility={queryUtility} fromPropertyName="dateOfServiceFrom" toPropertyName="dateOfServiceTo" store={rangeQueryPickerStore} timeZone="UTC" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={corporateStore} propertyName="corporateId" label="Corporate" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

MissingInventoryFlagReportListTemplate.propTypes = {
    missingInventoryFlagReportListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(MissingInventoryFlagReportListTemplate);